export const ACTION_GET_INTEGRATION = 'get-integration'
export const ACTION_COPY_INTEGRATION = 'copy-integration'
export const ACTION_GET_TEAM_INTEGRATIONS = 'get-team-integrations'
export const ACTION_DELETE_INTEGRATION = 'delete-integration'
